module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_12.31dd6575.jpg";